<div [hidden]="!visible">
    <div class="text-center">
        <div class="spinner-border spinner-dimension-100 m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div class="text-center" [hidden]="!isVisibleText">
        <strong>{{message}}</strong>
    </div> 
</div>

